import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  report: null,
  previousReports: [],
  loading: false,
  isReviewMode: false,
};

const amendmentsSlice = createSlice({
  name: "amendments",
  initialState: INITIAL_STATE,
  reducers: {
    setReport: (state, action) => {
      state.report = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setPreviousReports: (state, action) => {
      state.previousReports = action.payload;
    },
    setIsReviewMode: (state, action) => {
      state.isReviewMode = action.payload;
    },
    deleteReport: (state, action) => {
      state.previousReports = state.previousReports.filter(
        (report) => report.reportId !== action.payload
      );
    },
    updateReportName: (state, { payload: { reportId, name } }) => {
      state.previousReports = state.previousReports.map((report) =>
        report.reportId === reportId ? { ...report, name } : report
      );
      if (state.report && state.report.reportId === reportId) {
        state.report = { ...state.report, name };
      }
    },
    updateMultipleAmendments: (state, action) => {
      const { ids = [], changes = {} } = action.payload || {};

      if (!Array.isArray(ids) || ids.length === 0) {
        return;
      }

      state.report.compareResults = state.report.compareResults.map((item) =>
        ids.includes(item.id) ? { ...item, ...changes } : item
      );
    },
  },
});

export const {
  setReport,
  setLoading,
  setPreviousReports,
  setIsReviewMode,
  deleteReport,
  updateMultipleAmendments,
  updateReportName,
} = amendmentsSlice.actions;

export default amendmentsSlice.reducer;
